module.exports = __webpack_public_path__ + "static/Foundation-e20945d7c929279ef7a6f1db184a4470.ttf";